import { iGameTemplate, iSquareSaved, iCluesInfos, iGameState } from "../context/interfaces";
import { searchHorizontal, searchVertical } from "./searchs";
import setSubFocus from "./setSubFocus";


export default function getNextClue(
  gameState: iGameState,
  gameTemplate: iGameTemplate,
): void {
  // currentClueText: string,
  // currentClueNumber: string,
  // orientation: "horizontal" | "vertical",
  // focusedHouse: { x: number, y: number },
  const { matrix } = gameState.savedGame.cache;
  const { row } = gameState.focusedHouse;

  //console.log("column-", gameState.focusedHouse.column)
  if (gameState.orientation === "horizontal") {
    //serach next possible house on current row
    for (let column = gameState.focusedHouse.column; column < matrix[row].length; column++) {
      if (matrix[row][column]?.palavraHorizontal !== -1 && matrix[row][column].palavraHorizontal?.toString() !== gameState.currentClueNumber) {
        if (matrix[row][column]?.letra === null || matrix[row][column]?.letra === '') {
          //We have a avaible house
          //console.log('Avaible house horixontal at',row,'-',column,': ', matrix[row][column]);

          gameState.currentClueNumber = matrix[row][column].palavraHorizontal.toString();
          gameState.currentClueText = gameTemplate.chaves.horizontal[matrix[row][column].palavraHorizontal.toString()][0].chave;
          var subFocus = setSubFocus({
            selectedClue: gameState.currentClueNumber,
            orientation: "horizontal",
            focusedHouse: { column, row },
            houseStates: gameState.houseStates
          });
          gameState.houseStates = subFocus.houseStates;
          gameState.focusedHouse = subFocus.focusedHouse;

          return;
        }
      }
    }
    //if has more rows search next possible house on next rows
    if (gameState.focusedHouse.row + 1 <= matrix.length) {
      for (let row = gameState.focusedHouse.row + 1; row < matrix.length; row++) {
        for (let column = 0; column < matrix[row].length; column++) {
          if (matrix[row][column]?.palavraHorizontal !== -1 && matrix[row][column]?.palavraHorizontal.toString() !== gameState.currentClueNumber) {
            if (matrix[row][column]?.letra === null || matrix[row][column]?.letra === '') {
              //We have a avaible house
              //console.log('Avaible house horixontal at',row,'-',column,': ', matrix[row][column]);
              gameState.currentClueNumber = matrix[row][column].palavraHorizontal.toString();

              gameState.currentClueText = gameTemplate.chaves.horizontal[matrix[row][column].palavraHorizontal.toString()][0].chave;
              var subFocus = setSubFocus({
                selectedClue: gameState.currentClueNumber,
                orientation: "horizontal",
                focusedHouse: { column, row },
                houseStates: gameState.houseStates
              });
              gameState.houseStates = subFocus.houseStates;
              gameState.focusedHouse = subFocus.focusedHouse;
              return;
            }


          }
        }
      }
    }

    //turn the orientation to vertical and  search next possible house
    var verticalResult = searchVertical(gameState.savedGame.cache.matrix, gameTemplate, "", "", "vertical");
    if (false !== verticalResult) {
      gameState.currentClueNumber = verticalResult.clueNumber;
      gameState.currentClueText = gameTemplate.chaves.vertical[verticalResult.clueNumber.toString()][0].chave;
      var subFocus = setSubFocus({
        selectedClue: gameState.currentClueNumber,
        orientation: "vertical",
        focusedHouse: { column: verticalResult.focusedHouse.column, row: verticalResult.focusedHouse.row },
        houseStates: gameState.houseStates
      });
      gameState.houseStates = subFocus.houseStates;
      gameState.focusedHouse = subFocus.focusedHouse;
      gameState.orientation = "vertical";
      return;
    }
    //back to horizontal and search
    var horizontalResult = searchHorizontal(gameState.savedGame.cache.matrix, gameTemplate, "", "", "horizontal");
    if (false !== horizontalResult) {
      gameState.currentClueNumber = horizontalResult.clueNumber;
      gameState.currentClueText = gameTemplate.chaves.horizontal[horizontalResult.clueNumber.toString()][0].chave;
      var subFocus = setSubFocus({
        selectedClue: gameState.currentClueNumber,
        orientation: "horizontal",
        focusedHouse: { column: horizontalResult.focusedHouse.column, row: horizontalResult.focusedHouse.row },
        houseStates: gameState.houseStates
      });
      gameState.houseStates = subFocus.houseStates;
      gameState.focusedHouse = subFocus.focusedHouse;
      return;
    }
    gameState.completed = true;

    console.log("Game finished!");


  } else if (gameState.orientation === "vertical") {
    //serach next possible house on current column
    for (let row = gameState.focusedHouse.row; row < matrix.length; row++) {
      if (matrix[row][gameState.focusedHouse.column]?.palavraVertical !== -1 && matrix[row][gameState.focusedHouse.column]?.palavraVertical?.toString() !== gameState.currentClueNumber) {
        if (matrix[row][gameState.focusedHouse.column]?.letra === null || matrix[row][gameState.focusedHouse.column]?.letra === '') {
          //We have a avaible house
          //console.log('Avaible house vertical at',row,'-',column,': ', matrix[row][column]);
          gameState.currentClueNumber = matrix[row][gameState.focusedHouse.column]?.palavraVertical.toString();
          gameState.currentClueText = gameTemplate.chaves.vertical[matrix[row][gameState.focusedHouse.column]?.palavraVertical.toString()][0].chave;
          var subFocus = setSubFocus({
            selectedClue: gameState.currentClueNumber,
            orientation: "vertical",
            focusedHouse: { column: gameState.focusedHouse.column, row: row },
            houseStates: gameState.houseStates
          });
          gameState.houseStates = subFocus.houseStates;
          gameState.focusedHouse = subFocus.focusedHouse;
          return;
        }
      }
    }
    //if has more columns search next possible house on next columns
    if (gameState.focusedHouse.column + 1 <= matrix[gameState.focusedHouse.column].length) {
      for (let column = gameState.focusedHouse.column + 1; column < matrix[gameState.focusedHouse.column].length; column++) {
        for (let row = 0; row < matrix.length; row++) {
          if (matrix[row][column]?.palavraVertical !== -1 && matrix[row][column]?.palavraVertical.toString() !== gameState.currentClueNumber) {
            if (matrix[row][column]?.letra === null || matrix[row][column]?.letra === '') {
              //We have a avaible house
              //console.log('Avaible house vertical at',row,'-',column,': ', matrix[row][column]);
              gameState.currentClueNumber = matrix[row][column].palavraVertical.toString();
              gameState.currentClueText = gameTemplate.chaves.vertical[matrix[row][column].palavraVertical.toString()][0].chave;
              var subFocus = setSubFocus({
                selectedClue: gameState.currentClueNumber,
                orientation: "vertical",
                focusedHouse: { column, row },
                houseStates: gameState.houseStates
              });

              gameState.houseStates = subFocus.houseStates;

              gameState.focusedHouse = subFocus.focusedHouse;

              return;
            }
          }
        }
      }

    }

    //turn the orientation to horizontal and  search next possible house state
    var horizontalResult = searchHorizontal(gameState.savedGame.cache.matrix, gameTemplate, "", "", "horizontal");
    if (false !== horizontalResult) {
      gameState.currentClueNumber = horizontalResult.clueNumber.toString();
      gameState.currentClueText = gameTemplate.chaves.horizontal[horizontalResult.clueNumber.toString()][0].chave;
      var subFocus = setSubFocus({
        selectedClue: gameState.currentClueNumber,
        orientation: "horizontal",
        focusedHouse: { column: horizontalResult.focusedHouse.column, row: horizontalResult.focusedHouse.row },
        houseStates: gameState.houseStates
      });
      gameState.houseStates = subFocus.houseStates;
      gameState.focusedHouse = subFocus.focusedHouse;
      gameState.orientation = "horizontal";
      return;
    }
    //back to vertical and search

    var verticalResult = searchVertical(gameState.savedGame.cache.matrix, gameTemplate, "", "", "vertical");
    if (false !== verticalResult) {
      gameState.currentClueNumber = verticalResult.clueNumber.toString();
      gameState.currentClueText = gameTemplate.chaves.vertical[verticalResult.clueNumber.toString()][0].chave;
      var subFocus = setSubFocus({
        selectedClue: gameState.currentClueNumber,
        orientation: "vertical",
        focusedHouse: { column: verticalResult.focusedHouse.column, row: verticalResult.focusedHouse.row },
        houseStates: gameState.houseStates
      });
      gameState.houseStates = subFocus.houseStates;
      gameState.focusedHouse = subFocus.focusedHouse;
      return;
    }
    gameState.completed = true;

    console.log("Game finished!");
      }
}

